(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hs-collection-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!/^\/collections\/ofertas-squad\/?$/.test(window.location.pathname)) return;
    const money = new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'});
    function update(card) {
      const output = card.querySelector('[data-hc-squad-coupon-price]');
      if (!output) return;
      const input = card.querySelector('input[name="quantity"]');
      const quantity = Math.max(1, Number.parseInt(input?.value || '1', 10) || 1);
      const price = Number(card.dataset.hsQuantityPrice);
      if (!Number.isFinite(price)) return;
      const finalPrice = Math.round(price * quantity * 0.85);
      output.textContent = money.format(finalPrice / 100);
      const badge = card.querySelector('.hc-off');
      const regularPrice = Math.max(price, Number(card.dataset.hsQuantityCompare) || price);
      if (badge) badge.textContent = 'Economize ' + money.format((regularPrice * quantity - finalPrice) / 100);
    }
    function schedule(event) {
      const card = event.target.closest('[data-hc-card]');
      if (card) requestAnimationFrame(() => update(card));
    }
    document.addEventListener('click', schedule);
    document.addEventListener('input', schedule);
    document.addEventListener('change', schedule);
    const refresh = () => requestAnimationFrame(() => document.querySelectorAll('[data-hc-card]').forEach(update));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once: true});
    else refresh();
    window.addEventListener('load', refresh, {once: true});
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["landing-styles"] && !Shopify.designMode) return;
  try {
    (function($) {
    if (typeof $ === 'undefined') return;
    
    // Smooth scroll para links âncora
    $(document).on('click', 'a[href^="#"]', function(e) {
      var target = $(this.getAttribute('href'));
      if (target.length) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top - 25
        }, 600);
      }
    });
  })(typeof jQuery !== 'undefined' ? jQuery : null);
  } catch(e) { console.error(e); }
})();

})();
